import {ReactNode} from 'react'

import './Overlay.scss'

interface OverlayProps {
  children: ReactNode
}

export default function Overlay({children}: OverlayProps) {
  return <div className="Overlay">{children}</div>
}
